module.exports = __webpack_public_path__ + "img/volume-overview.721e142d.png";